export function updateMobileLinks(param, value) {
  /**
   * Mobile links
   */

  let mobileCTA = document.getElementsByClassName("mobile-cta-button")[0];
  if (undefined !== mobileCTA) {
    let url = new URL(mobileCTA.href);
    url.searchParams.set(param, value);
    mobileCTA.href = url.href;
    //    mobileCTA.href = mobileCTA.href + "?ref=" + rentalzAffiliateTracking.code;
  }

  let mobileDestinations = document.getElementById("destination-modal");
  if (null !== mobileDestinations) {
    mobileDestinations
      .querySelectorAll(".destination-cta")
      .forEach(function (dest, i) {
        let url = new URL(dest.href);
        url.searchParams.set(param, value);
        dest.href = url.href;
        //        dest.href = dest.href + "?ref=" + rentalzAffiliateTracking.code;
      });
  }
}
